var _circle, _path, _path2, _path3, _g, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenCreateModal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#00EE8A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7447 4.50284C34.3378 3.05162 41.8003 4.81552 47.7274 8.8405C53.6544 12.8655 58.0459 19.1516 59.4972 26.7447C60.9484 34.3378 59.1845 41.8003 55.1595 47.7274C51.1345 53.6544 44.8484 58.0459 37.2553 59.4972C29.6622 60.9484 22.1997 59.1845 16.2726 55.1595C10.3456 51.1345 5.95405 44.8484 4.50284 37.2553C3.05162 29.6622 4.81552 22.1997 8.8405 16.2726C12.8655 10.3456 19.1516 5.95405 26.7447 4.50284Z",
    fill: "#11141C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.375 32C57.375 46.0142 46.0142 57.375 32 57.375C17.9858 57.375 6.625 46.0142 6.625 32C6.625 17.9858 17.9858 6.625 32 6.625C46.0142 6.625 57.375 17.9858 57.375 32Z",
    fill: "url(#paint0_linear_4805_19860)",
    stroke: "#00BA6C",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.856 35.4701C47.5483 31.4181 56 44.7372 56 31.6665C56 18.5959 45.2548 8 32 8C18.7452 8 8 18.5959 8 31.6665C8 44.7372 14.1638 39.522 30.856 35.4701Z",
    fill: "url(#paint1_linear_4805_19860)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4805_19860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 54C44.1503 54 54 44.1503 54 32C54 19.8497 44.1503 10 32 10C19.8497 10 10 19.8497 10 32C10 44.1503 19.8497 54 32 54Z",
    stroke: "url(#paint2_linear_4805_19860)",
    strokeWidth: 0.465371
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44 32C44 32.3978 43.842 32.7794 43.5607 33.0607C43.2794 33.342 42.8978 33.5 42.5 33.5H33V43C33 43.3978 32.842 43.7794 32.5607 44.0607C32.2794 44.342 31.8978 44.5 31.5 44.5C31.1022 44.5 30.7206 44.342 30.4393 44.0607C30.158 43.7794 30 43.3978 30 43V33.5H20.5C20.1022 33.5 19.7206 33.342 19.4393 33.0607C19.158 32.7794 19 32.3978 19 32C19 31.6022 19.158 31.2206 19.4393 30.9393C19.7206 30.658 20.1022 30.5 20.5 30.5H30V21C30 20.6022 30.158 20.2206 30.4393 19.9393C30.7206 19.658 31.1022 19.5 31.5 19.5C31.8978 19.5 32.2794 19.658 32.5607 19.9393C32.842 20.2206 33 20.6022 33 21V30.5H42.5C42.8978 30.5 43.2794 30.658 43.5607 30.9393C43.842 31.2206 44 31.6022 44 32Z",
    fill: "url(#paint3_linear_4805_19860)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4805_19860",
    x: 9.53489,
    y: 9.5344,
    width: 44.9302,
    height: 44.9312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.116343,
    result: "effect1_foregroundBlur_4805_19860"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4805_19860",
    x1: 32,
    y1: 58,
    x2: 48.6588,
    y2: 12.0379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50BAAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4805_19860",
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 26.0017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4805_19860",
    x1: -0.451857,
    y1: 1.37941,
    x2: 69.6677,
    y2: 46.8209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.100982,
    stopColor: "white",
    stopOpacity: 0.607599
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194134,
    stopColor: "white",
    stopOpacity: 0.728666
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281272,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741712,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4805_19860",
    x1: 31.5264,
    y1: 25.6199,
    x2: 31.5264,
    y2: 44.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F5",
    stopOpacity: 0.15
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenCreateModal);
export default __webpack_public_path__ + "static/media/openCreateModal.2215b33b645e6363fc137724ddc4b896.svg";
export { ForwardRef as ReactComponent };